var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup9537(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8586",
    "data-name": "Rectangle 8586",
    width: 35,
    height: 35,
    transform: "translate(0.491)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9537",
    "data-name": "Group 9537",
    transform: "translate(-0.491)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14581",
    "data-name": "Path 14581",
    d: "M1199.14,283H1169.1a2.567,2.567,0,0,0-2.6,2.541v30.166a2.573,2.573,0,0,0,2.6,2.547h30.04a2.585,2.585,0,0,0,2.615-2.541V285.541A2.58,2.58,0,0,0,1199.14,283Zm-22.181,30.043h-5.229v-16.83h5.229Zm-2.615-19.123a3.03,3.03,0,1,1,3.026-3.029A3.038,3.038,0,0,1,1174.344,293.92Zm22.2,19.123h-5.229v-8.18c0-1.949-.029-4.463-2.718-4.463-2.718,0-3.129,2.129-3.129,4.325v8.319h-5.215v-16.83h5.009v2.3h.073a5.47,5.47,0,0,1,4.936-2.72c5.3,0,6.272,3.484,6.272,8.016Z",
    transform: "translate(-1166.5 -283)",
    fill: "#858689"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9537);
export default __webpack_public_path__ + "static/media/Group9537.5614229103900cc229bc972a1a0c9fd7.svg";
export { ForwardRef as ReactComponent };